import type { ArrowDirection } from 'LuxKit/Carousel/CardCarousel'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'
import { EventDataKey } from 'home/pages/HomePage/useHomepageAnalytics'
import React, { useCallback, useContext } from 'react'

interface Props extends React.ComponentProps<typeof FullWidthCarousel> {}

/**
  * This component is simply a wrapper around `LuxKit/Carousel/FullWidthCarousel`
  */
const FullWidthCarouselWithAnalytics = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const dispatchOfferListEvent = useContext(OfferListEventsContext)
  const onArrowClick = useCallback((_e: React.MouseEvent<HTMLButtonElement>, arrow: ArrowDirection) => {
    dispatchOfferListEvent({
      type: OfferListEvents.clientAction,
      action: 'pressed',
      subject: arrow === 'right' ? 'carousel next button' : 'carousel prev button',
      key: EventDataKey.ClientAction,
    })
  }, [dispatchOfferListEvent])

  return <FullWidthCarousel
    {...props}
    ref={ref}
    onArrowClick={onArrowClick}
  />
})

FullWidthCarouselWithAnalytics.displayName = 'FullWidthCarouselWithAnalytics'

export default FullWidthCarouselWithAnalytics
